/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CountriesService {
    /**
     * List all countries
     * Get a paginated list of all countries
     * @param search Search by country name or sortname
     * @param perPage Items per page
     * @returns any List of countries
     * @throws ApiError
     */
    public static a08Ff99B9Afd86C714C683Cb74C584B8(
        search?: string,
        perPage: number = 15,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/countries',
            query: {
                'search': search,
                'per_page': perPage,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Get a specific country
     * Retrieve details of a specific country with its states
     * @param id Country ID
     * @returns any Country details
     * @throws ApiError
     */
    public static b650C2Bdb0B69838471965D3F0814B5(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/countries/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Country not found`,
            },
        });
    }
}
